import { Refresh } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import ControleGabineteStore from '../../store/ControleGabineteStore';

/**
 * Aparece enquanto há atualizações do envelope retidas porque o usuário está interagindo com o
 * Kanban. Deve ficar dentro da área que pausa as atualizações: assim mover o mouse até o aviso não
 * conta como "sair" da área e aplicar tudo antes do clique.
 */
const AvisoAtualizacoesPendentes: React.FC = observer(() => {
    const quantidade = ControleGabineteStore.quantidadeAtualizacoesPendentes;

    if (!ControleGabineteStore.atualizacoesPausadas || quantidade === 0) {
        return null;
    }

    return (
        <Chip
            color="primary"
            icon={<Refresh />}
            label={`${quantidade} ${quantidade === 1 ? 'atualização pendente' : 'atualizações pendentes'} — clique para atualizar`}
            onClick={ControleGabineteStore.retomarAtualizacoes}
            sx={{
                position: 'fixed',
                bottom: 24,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1200,
                boxShadow: 3,
                cursor: 'pointer'
            }}
        />
    );
});

export default AvisoAtualizacoesPendentes;
